export const GET_DATA_OF_PAGE = 'GET_DATA_OF_PAGE';
export const GET_SIZE_OF_CART = 'GET_SIZE_OF_CART';